import { h } from 'preact';
import cn from 'classnames';
import { t } from '../../utils/i18n';
import { location } from '../../env/browser';

const TrialMessage = ({ trialDaysLeft, isHiddenSm, isVisibleSm }) => {
  const { origin } = location;

  return trialDaysLeft !== null && trialDaysLeft >= 0 ? (
    <div
      class={cn('as-TrialMessage', {
        'is-hidden-sm': isHiddenSm,
        'is-visible-sm': isVisibleSm,
      })}
    >
      <div className="as-TrialMessage-daysIconContainer">
        <div className="as-TrialMessage-daysIcon">
          <div className="as-TrialMessage-daysIconDays">{trialDaysLeft}</div>
          <div className="as-TrialMessage-daysIconText">
            {trialDaysLeft === 1
              ? t('trial-days.days-singular')
              : t('trial-days.days-multiple')}
          </div>
        </div>
      </div>
      <div className="as-TrialMessage-infoText">
        <b className="as-TrialMessage-infoTextBold">
          {t('trial-days.message-before-link-multiple', {
            days: trialDaysLeft,
          })}
        </b>
        <a
          className="as-TrialMessage-infoTextLink"
          href={`${origin}/contract`}
          data-route
        >
          {t('trial-days.message-link-text')}
        </a>
        {t('trial-days.message-after-link')}
      </div>
    </div>
  ) : null;
};

export default TrialMessage;
